// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        routeParams: JSON.parse(localStorage.getItem('routeParams')) || {},
        agreementProtocols: []
    },
    mutations: {
        SET_ROUTE_PARAMS(state, params) {
            state.routeParams = params
            // 同时存储到 localStorage
            localStorage.setItem('routeParams', JSON.stringify(params))
        },
        UPDATE_ROUTE_PARAM(state, { key, value }) {
            state.routeParams[key] = value
            localStorage.setItem('routeParams', JSON.stringify(state.routeParams))
        },
        SET_AGREEMENT_PROTOCOLS(state, protocols) {
            state.agreementProtocols = protocols || []
        }
    },
    actions: {
        loadRouteParams({ commit }, params) {
            commit('SET_ROUTE_PARAMS', params)
        }
    }
})
